<template lang="pug">
  v-layout.member(wrap)
    v-alert(v-model="noDeletableDialog" type="error" dismissible) Не удается удалить участника ({{ noDeletableMember }}), так как на него уже созданы и отправлены документы по делу.

    v-flex(v-for="(m, index) in members" :key="index" xs6)
      app-card.member__card(@click.native="selectMember(m)")
        app-card-body.member__body
          v-layout
            v-flex(align-content-start)
              .member__name(v-line-clamp="2") {{ m.displayName }} 
              app-card-caption(v-if="m.persona.personaType.name == 'UL'") Представитель: {{ m.persona.name }}
              app-card-caption(v-if="m.persona.email") {{ m.persona.email }}
              app-card-caption(v-if="m.persona.phone") {{ m.persona.phone }}
              app-card-caption(v-if="m.authCode && m.authCode.code!=''") Одноразовый пароль:  
                strong(@click.stop="copy(m.authCode.code)") {{ m.authCode.code }}  
                span.exp (до {{expDate(m.authCode.expires)}})

        app-card-footer {{ m.status.title }} ({{ m.persona.personaType.title }} )


    app-dialog(v-model="dialog.member" :header="memberName" :items="items")
    CaseAddDocument(v-model="dialog.document" :member.sync="member")

    app-dialog-confirm(v-model="dialog.memberDelete" @confirm="deleteMemberFromSession()")
      app-card-title.mt-5 Вы уверены, что хотите удалить участника "<b>{{ memberName }}</b>"?

    v-snackbar(v-model="codeSnack" color="success" :timeout="6000" vertical top) Код скопирован
      v-btn(light text @click="codeSnack = false") Закрыть

</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { AppToolbarItemDivider } from '@/components'
import { AppDialogConfirm } from '@/components'

import { memberService } from "@/_services"
import CaseAddDocument from './CaseAddDocument'
import Meeting from '@/common/Meeting'

import moment from 'moment'

export default {
  mixins: [Meeting],

  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    CaseAddDocument,
  },

  data () {
    return {
      dialog: {
        member: false,
        document: false,
        memberDelete: false
      },
      member: null,
      noDeletableMember: null,
      noDeletableDialog: false,
      codeSnack: false
    }
  },
  
  computed: {
    ...mapGetters('courtCase', ['caseId', 'members', 'docsGas', 'isActiveSession']),

    items () {
      let items = [ this.itemSelect]
      if (this.isActiveSession ) {
        items.push(this.itemCreateTemplate, AppToolbarItemDivider )
        if (this.$_meeting_isAvailable) items.push(this.itemGenCode)
        items.push(this.itemEdit, this.itemDelete)
      }
      
      return items
    },

    itemSelect () { return { icon: 'remove_red_eye', title: 'Показать все документы', action: () => this.setSelectedMember(this.member) }},
    itemCreateTemplate () { return { icon: 'note', title: 'Создать шаблонный документ', action: () => this.showAddDocumentForm() }},
    itemGenCode () { return { icon: 'code', title: 'Сгенерировать одноразовый пароль', action: () => this.genCode() }},
    itemEdit () { return { icon: 'person', title: 'Редактировать профиль участника', action: () => this.goToMemberForm() }},
    itemDelete () { return { icon: 'delete', title: 'Удалить из текущей сессии', action: () => this.showDeleteDialog() }},

    memberName () {
      return this.member ? this.member.displayName : 'Сторона по делу'
    }
  },

  methods: {
    ...mapMutations('courtCase', ['setSelectedMember']),

    expDate (date) {
      return moment(date).format("DD.MM.YYYY HH:mm")
    },

    copy (code) {
      navigator.clipboard.writeText(code)
      .then(() => { this.codeSnack=true })
    },

    selectMember (member) {
      this.member = member
      this.dialog.member = true
    },

    showDeleteDialog () {
      this.dialog.memberDelete = true
    },

    showAddDocumentForm () {
      this.dialog.document = true
    },

    genCode () {
      memberService.genCode(this.member.id).then(() => {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
      })
    },

    deleteMemberFromSession () {
      memberService.deleteFromSession(this.member.id)
      .then(() => {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
      })
      .catch(({ response }) => {
        if (response && response.status == 403) {
          this.noDeletableMember = this.member.displayName
          this.noDeletableDialog = true
        }
      })
    },

    goToMemberForm () {
      this.$router.push(`${this.caseId}/member/${this.member.id}`)
    }
  }
}
</script>


<style lang="scss" scoped>
.member {
  margin: 0px -8px;
}
.member__card {
  margin: 0px 8px 16px;
}
.member__body {
  min-height: 84px;
}
.member__name {

  font-family: 'Roboto Condensed', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;

  color: #757575;

  word-break: break-word !important;

  // display: flex;
  // align-items: center;
}
.exp {
  color: #AAAAAA;
}
</style>
